<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="this.$route.meta.cargo" />
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>

          <div class="tile internbackground painel">
            <div class="navbackground">
              <p>
                Olá <span>{{name}}</span>, esta é sua área de edição dos conteúdo da biblioteca
              </p>
            </div>
            <div class="tile dash-painel flex-wrap columns is-mobile">
              <div class="column is-5">
                <article class="tile notification tiledash linkbox">
                  <p>Realizar Um Novo Cadastro</p>
                  <router-link :to="{ name: 'proposta/create'}">
                    <figure>
                      <div class="imagecontainer">
                        <img
                          src="../../../assets/images/icon-color/new-document.svg"
                          class
                          alt="redonline"
                        />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Proposta</caption>
                    </figure>
                  </router-link>

                  <router-link :to="{ name: 'admin/biblioteca/coletanea/create'}">
                    <figure>
                      <div class="imagecontainer">
                        <img
                          src="../../../assets/images/icon-color/coletaneas.svg"
                          class
                          alt="redonline"
                        />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Coletânea</caption>
                    </figure>
                  </router-link>

                  <router-link :to="{ name: 'admin/biblioteca/teaser/create'}">
                    <figure>
                      <div class="imagecontainer">
                        <img
                          src="../../../assets/images/icon-color/videoaulas.svg"
                          class
                          alt="redonline"
                        />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Teaser</caption>
                    </figure>
                  </router-link>

                  <router-link :to="{ name: 'material/create'}">
                    <figure>
                      <div class="imagecontainer">
                        <img
                          src="../../../assets/images/icon-color/materiais.svg"
                          class
                          alt="redonline"
                        />
                        <b-icon class="icon-addcircle" type="hidden"></b-icon>
                      </div>
                      <caption>Materiais</caption>
                    </figure>
                  </router-link>
                </article>
              </div>

              <div class="column is-4">
                <div class="tile boxrotate notification bannerbox tiledash blue-gradient">
                  <img
                    src="../../../assets/images/panels/propostas.svg"
                    class="image-card"
                    alt="redonline"
                  />

                  <router-link :to="{ name: 'proposta', params: { }}">
                    <div class="tile notification tiledashbox">
                      <h2>Gerenciar Propostas</h2>
                      <p>VIDEOAULAS, TEXTO BASE DAS PROPOSTAS</p>
                    </div>
                  </router-link>
                </div>
              </div>

              <div class="column is-3">
                <div class="tile boxrotate notification bannerbox tiledash green-gradient">
                  <img
                    src="../../../assets/images/panels/simulados.svg"
                    class="image-card"
                    alt="redonline"
                  />

                  <router-link :to="{ name: 'admin/simulado', params: { }}">
                    <div class="tile notification tiledashbox">
                      <h2>Visualisar Simulados</h2>
                      <p>VIDEOAULAS, TEXTO BASE DOS SIMULADOS</p>
                    </div>
                  </router-link>
                </div>
              </div>

              <div class="column is-4">
                <div class="tile boxrotate notification tiledash bannerbox orange-gradient">
                  <img
                    src="../../../assets/images/panels/coletaneas.svg"
                    class="image-card"
                    alt="redonline"
                  />

                  <router-link :to="{ name: 'admin/biblioteca/coletanea', params: { }}">
                    <div class="tile notification tiledashbox">
                      <h2>Gerenciar Coletâneas</h2>
                      <p>CONJUNTO DE VIDEOAULAS, MATERIAIS DE APOIO, TEXTOS E ETC</p>
                    </div>
                  </router-link>
                </div>
              </div>

              <div class="column is-4">
                <div class="tile boxrotate notification bannerbox tiledash pink-gradient">
                  <img
                    src="../../../assets/images/panels/teaser.svg"
                    class="image-card"
                    alt="redonline"
                  />

                  <router-link :to="{ name: 'admin/biblioteca/teaser', params: { }}">
                    <div class="tile notification tiledashbox">
                      <h2>Gerenciar Teasers</h2>
                      <p>VIDEOAULAS, CHAMADAS, NOTICÍAS E ETC</p>
                    </div>
                  </router-link>
                </div>
              </div>

              <div class="column is-4">
                <div class="tile boxrotate notification tiledash bannerbox yellow-gradient">
                  <img
                    src="../../../assets/images/panels/materiais.svg"
                    class="image-card"
                    alt="redonline"
                  />

                  <router-link :to="{ name: 'material', params: { }}">
                    <div class="tile notification tiledashbox">
                      <h2>Gerenciar Materiais</h2>
                      <p>REVISTAS, IMAGENS, REDAÇÕES NOTA 1000 E ETC</p>
                    </div>
                  </router-link>
                </div>
              </div>
            </div>
          </div>
          <internfooter class="footer-painel" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";

export default {
  data() {
    return {
      name: store.getters.name
    };
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
  }
};
</script>
<style scoped>
footer.footer.redfooter.footer-painel >>> .div-credits {
  display: none !important;
}
.tiledashbox p {
  line-height: 1em;
  height: 15px;
  display: block;
}
img.image-card {
  margin: 10px auto auto;
}
</style>